import React from "react";
import { Button, Row, Col, Table } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';


import ss from '../images/seniorspray_round.png';


export default function CompletePage() {
	
	const location = useLocation();
	const order = location.state;
	const cust = order.customer_details;
	const ship = cust.address;

	return (
    <>
        <div>
            <Row className = 'text-center'>
             <Col>
			 <br />
			 <br />
			 <img src={ss} style={{width: '250px'}} alt='senior spray' />
			 <br />
			 <br />
			 <h6>Thank you for your purchase of Senior Spray, below are the details from your order. A confirmation message has been sent...</h6>
			 <br />
			 <br />
                <Button variant="primary" href='/'>Home</Button>
    <div>
	 <br />
	 <br />
	  <Table striped bordered className = 'text-start'>
	   <tbody>
	   <tr>
	    <td className='bold'>Customer Name:</td>
		<td>{cust.name}</td>
	   </tr>
	   <tr> 
	    <td className='bold'>Email:</td>
		<td>{cust.email}</td>
	   </tr>
	   <tr> 
	    <td className='bold'>Phone:</td>
		<td>{cust.phone}</td>
	   </tr>
	   <tr>
	    <td className='bold align-top'>Shipping To:</td>
		<td>{ship.line1} <br />{ship.line2} <br />{ship.city}, {ship.state}, {ship.country} <br/ > {ship.postal_code}</td>
	   </tr>
	   </tbody>
	  </Table>
	  <br />
	  <small style={{size: '5px'}}>Payment Status: <b>{order.status}</b> <br />
	  {order.id}</small>
	  </div>

             </Col>
            </Row>
        </div>
    </>

	);

}
